import React from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { ReactComponent as WindowsIcon } from "svg/windows.svg";
import { ReactComponent as AppleIcon } from "svg/apple.svg";
import { ReactComponent as CloudDownloadIcon } from "svg/download-cloud-fill.svg";

export default function AppDownloadButton(props) {
  const { className, url, label, icon, dim, download, target, href } = props;

  const icons = {
    windows: <WindowsIcon className="download-btn_icon windows-icon" />,
    apple: <AppleIcon className="download-btn_icon apple-icon" />,
    cloud: <CloudDownloadIcon className="download-btn_icon windows-icon" />,
  };

  const commonProps = {
    className: classnames(
      "btn-red btn-red_hover download-btn",
      {
        "btn-red_dim": dim,
      },
      className,
    ),
    target,
    download,
  };

  const content = (
    <>
      {icons[icon]}
      <span>{label}</span>
    </>
  );

  if (href) {
    return (
      <a {...commonProps} href={url}>
        {content}
      </a>
    );
  }

  return (
    <Link {...commonProps} to={url}>
      {content}
    </Link>
  );
}
